class ProductPopup extends HTMLElement {
  constructor() {
    super();
    this.popupTriggerClickHandler = this.popupTriggerClickHandler.bind(this);
    this.popupClickHandler = this.popupClickHandler.bind(this);
    this.trigerOptionsClickHandler = this.trigerOptionsClickHandler.bind(this);
    this.popupClose = this.popupClose.bind(this);
  }
  connectedCallback() {
    this.init();
    this.initEvents();
    this.initCountdowns();
    this.checkScroll();
  }
  init() {
    this.popupTrigger = document.querySelector(
      `[data-popup-triger="${this.dataset.popup}"]`
    );
    this.popupCloseButton = this.querySelector(`[data-popup-close]`);
    this.trigerOptions = this.querySelectorAll("[data-triger-option]");
    this.customLinks = this.querySelectorAll("[data-open-url]");
    this.offerDeadlines = this.querySelectorAll("[data-deadline]");
    this.popupContent = this.querySelector(".product-popup__content");
    this.popupContentDebounced = window.theme.debounce(
      this.checkScroll.bind(this),
      50
    );
  }
  initEvents() {
    this.removeEvents();

    this.popupTrigger.addEventListener("click", this.popupTriggerClickHandler);
    this.popupCloseButton.addEventListener("click", this.popupClose);
    this.addEventListener("click", this.popupClickHandler);

    this.trigerOptions?.forEach((option) => {
      option.addEventListener("click", this.trigerOptionsClickHandler);
    });

    if (this.dataset.popupOptionName) {
      if (!this.documentChangeHandler) {
        this.documentChangeHandler = (e) => {
          if (e.target.dataset.optionName == undefined) return;
          if (e.target.dataset.optionName === this.dataset.popupOptionName) {
            this.popupClose();
            this.updateActiveOption(e.target.value);
          } else {
            this.renderPopup(this.dataset.popup);
          }
        };
        document.addEventListener("change", this.documentChangeHandler);
      }
    }

    this.customLinks?.forEach((link) => {
      const handler = (e) => {
        if (e.target.tagName == "A") return;
        e.preventDefault();
        window.location.href = link.dataset.openUrl;
      };
      link.addEventListener("click", handler);
    });

    this.popupContent.addEventListener("scroll", this.popupContentDebounced);
  }
  removeEvents() {
    if (this.popupTrigger) {
      this.popupTrigger.removeEventListener(
        "click",
        this.popupTriggerClickHandler
      );
    }
    if (this.popupCloseButton) {
      this.popupCloseButton.removeEventListener("click", this.popupClose);
    }
    this.removeEventListener("click", this.popupClickHandler);

    this.trigerOptions?.forEach((option) => {
      option.removeEventListener("click", this.trigerOptionsClickHandler);
    });

    if (this.popupContent && this.popupContentDebounced) {
      this.popupContent.removeEventListener(
        "scroll",
        this.popupContentDebounced
      );
    }
  }
  popupTriggerClickHandler() {
    if (this.classList.contains("open")) {
      this.popupClose();
    } else {
      this.popupOpen();
    }
  }
  popupClickHandler(e) {
    if (!e.target.closest(".popup-content__wrapper")) {
      this.popupClose();
    }
  }
  trigerOptionsClickHandler(e) {
    let newOption = e.target.closest("[data-triger-option]").dataset
      .trigerOption;
    this.popupTrigger
      .closest(".radio__fieldset")
      ?.querySelectorAll('input[type="radio"]')
      ?.forEach((input) => {
        if (input.value === newOption) {
          input.click();
          return;
        }
      });
  }
  disconnectedCallback() {
    this.removeEvents();
    if (this.documentChangeHandler) {
      document.removeEventListener("change", this.documentChangeHandler);
      this.documentChangeHandler = null;
    }
  }
  checkScroll() {
    const hasScroll =
      this.popupContent.scrollHeight > this.popupContent.clientHeight;
    const scrolledToBottom =
      this.popupContent.scrollTop + this.popupContent.clientHeight >=
      this.popupContent.scrollHeight - 1;

    if (hasScroll && !scrolledToBottom) {
      this.popupContent.classList.add("show-scroll-shadow");
    } else {
      this.popupContent.classList.remove("show-scroll-shadow");
    }
  }
  initCountdowns() {
    this.offerDeadlines?.forEach((el) => {
      const deadline = el.dataset.deadline;
      const offerContainer = el.closest(".product-popup__content_offer");

      const update = () => {
        const endTime = new Date(deadline);
        const now = new Date();
        const diffMs = endTime - now;

        if (diffMs <= 0) {
          if (offerContainer) offerContainer.remove();
          if (this.popupContent.textContent.trim() == "") {
            this.popupTrigger.remove();
            this.popupClose();
            this.remove();
          }
          return;
        }

        const totalSeconds = Math.floor(diffMs / 1000);
        const days = Math.floor(totalSeconds / (60 * 60 * 24));
        const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
        const seconds = totalSeconds % 60;
        const format = (n) => String(n).padStart(2, "0");

        el.textContent = window.offer_expiration_time_template
          .replace("{{ days }}", days)
          .replace("{{ hours }}", format(hours))
          .replace("{{ minutes }}", format(minutes))
          .replace("{{ seconds }}", format(seconds));
      };

      update();
      const interval = setInterval(() => {
        const endTime = new Date(deadline);
        if (endTime - new Date() <= 0) {
          clearInterval(interval);
          if (offerContainer) offerContainer.style.display = "none";
          return;
        }
        update();
      }, 1000);
    });
  }
  async renderPopup(optionName) {
    try {
      await fetch(window.location.href)
        .then((response) => response.text())
        .then((data) => {
          const html = new DOMParser().parseFromString(data, "text/html");
          const newPopup = html.querySelector(`[data-popup="${optionName}"]`);
          document.querySelector(`[data-popup="${optionName}"]`).innerHTML = newPopup.innerHTML;

          this.init();
          this.initEvents();
          this.initCountdowns();
        })
        .catch((error) => console.error("Error updating page:", error));
    } catch (error) {
      console.error(error);
    }
  }
  updateActiveOption(value) {
    this.trigerOptions?.forEach((option) => {
      if (option.dataset.trigerOption === value) {
        option.classList.add("selected");
        const activeTag = document.querySelector("[data-active-option-tag]");
        if (activeTag) {
          activeTag.innerHTML =
            option.querySelector(".variant-sale-tag")?.outerHTML || "";
        }
        let newActiveColor = window.getComputedStyle(
          option.querySelector(".product-popup__item--color")
        ).backgroundColor;
        if (newActiveColor) {
          document.querySelector(
            "[data-active-option-color]"
          ).style.backgroundColor = newActiveColor;
        }
      } else {
        option.classList.remove("selected");
      }
    });
  }
  popupOpen() {
    this.checkScroll();
    this.classList.add("open");
    document.documentElement.style.overflow = "hidden";
    // Only phones lock the body as well. Any overflow value on the body makes it the scroll
    // container of the sticky gallery, and a body that never scrolls releases it: the gallery
    // drops to its flow position the moment a popup opens.
    if (window.innerWidth < 750) {
      document.body.style.overflow = "hidden";
      document.body.style.overscrollBehaviorY = "none";
      document.body.style.touchAction = "none";
    }
    // The sticky add-to-cart bar is left alone: the popup's own z-index puts it over the bar, so
    // the sheet covers the button instead of the button covering the sheet's content.
    const wrapper = this.querySelector(".popup-content__wrapper");
    if (window.innerWidth < 750 && wrapper && wrapper.offsetHeight > window.visualViewport.height) {
      wrapper.style.height = `${window.visualViewport.height}px`;
    }
  }
  popupClose() {
    this.classList.remove("open");
    // Cleared, not set to "auto": "auto" leaves the body a scroll container for good, so the
    // gallery stops sticking for the rest of the visit.
    document.body.style.overflow = "";
    document.body.style.overscrollBehaviorY = "";
    document.body.style.touchAction = "";
    document.documentElement.style.overflow = "";
    // Cleaned up unconditionally: the width may have changed while it was open
    const wrapper = this.querySelector(".popup-content__wrapper");
    if (wrapper) wrapper.style.height = "";
  }
}

customElements.define("product-popup", ProductPopup);
